"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoffQuoteType = void 0;
var PayoffQuoteType;
(function (PayoffQuoteType) {
    PayoffQuoteType["paydown"] = "paydown";
    PayoffQuoteType["payoff"] = "payoff";
})(PayoffQuoteType || (exports.PayoffQuoteType = PayoffQuoteType = {}));
